import { signal } from "@preact/signals-react";

export const toasts = signal([])

export const addNotification = (message, type, surviveRedirect = false, headerMessage, textColor) => {
    // add the new notification to our toasts signal. Set redirectCount to 2 if the it is intended to persist after redirect to another page
    let _type = type ? type : 'danger'
    let _headerMessage = headerMessage ? headerMessage : (_type == 'success' ? 'Success' : 'Error'); // use headerMessage if passed. Otherwise use either Success or Error
    toasts.value = [...toasts.value, {
        type: _type,
        headerMessage: _headerMessage, 
        message: message ? message: '', 
        redirectCount: surviveRedirect ? 2 : 1, 
        textColor: textColor ? textColor : 'text-white'}]
}

// This function is called by our route handling code to clear out old notifications. 
export const clearNotifications = () => {
    // decrement the redirectCount of all messages
    const decrementedToasts = toasts.value.map(t => {
        return {type: t.type, headerMessage: t.headerMessage, message: t.message, redirectCount: t.redirectCount - 1, textColor: t.textColor}
    })

    // filter to just toasts that should still exist
    const filteredToasts = decrementedToasts.filter(t => t.redirectCount > 0)

    // update signal with remaining items
    toasts.value = filteredToasts
}

export const NotificationTypes = Object.freeze({
    ERROR: 'danger',
    INFO: 'info',
    SUCCESS: 'success'
})
